"use client";

import React from "react";
import { Dialog, Modal } from "staysure-component-library";
// import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

import { PolicyDocumentModalProps } from "@/types/policy-document-types";

import PolicyDocumentModalContent from "./policy-document-modal-content";

function PolicyDocumentModal({
  isOpen,
  setIsOpen,
  content,
}: Readonly<PolicyDocumentModalProps>) {
  return (
    <Modal
      onOpenChange={(e: boolean) => setIsOpen(e)}
      isOpen={isOpen}
      modalStyles={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className=" bg-surface-neutral-option-1 w-[327px] md:w-[416px] items-center justify-center  relative rounded-radius-lg"
      uderlayClassName="z-[200] bg-interactive-overlay-default"
    >
      <Dialog className=" relative" data-testid="policy-document-dialog">
        <PolicyDocumentModalContent
          modalTitle={content.popupTitle}
          modalContentUnauthorized={content.popupContentUnauthorized}
          modalContent={content.popupContent}
          modalButtonOne={content.popupBtnLabel}
          setIsOpen={setIsOpen}
        />
      </Dialog>
    </Modal>
  );
}

export default PolicyDocumentModal;
